<template>
  <div class="d-flex flex-column justify-content-center">
    <div class="preview-border" style="border-radius: 4px 4px 0px 0px;">
      <p class="preview-title m-0">カットライン</p>
    </div>
    <div class="preview-border">
      <div class="d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
        <div class="">
          <div class="col d-flex justify-content-between mx-5 my-2">
            <input class="me-2 radio-btn" type="radio" id="option1" value="1" v-model="isShowCutline" />
            <label class="d-block text-start" style="width: 100px;" for="option1">表示</label>
          </div>
          <div class="col d-flex justify-content-between mx-5 my-2">
            <input class="me-2 radio-btn" type="radio" id="option3" value="0" v-model="isShowCutline" />
            <label class="text-start" for="option3" style="width: 100px;">非表示</label>
          </div>
        </div>
      </div>
      <hr class="my-0">
      <div class="fw-bold" style="font-size: 12px; margin-top: 8px; width: 80px;">
        表示方法
      </div>
      <div class="d-flex flex-column" style="border-radius: 0px 0px 4px 4px;">
        <div class="">
          <div class="col d-flex justify-content-between mx-5 my-2">
            <input class="me-2 radio-btn" type="radio" id="option1" value="0" v-model="cutlineMode" />
            <label class="d-block text-start" style="width: 100px;" for="option1">塗り</label>
          </div>
          <div class="col d-flex justify-content-between mx-5 my-2">
            <input class="me-2 radio-btn" type="radio" id="option3" value="1" v-model="cutlineMode" />
            <label class="text-start" for="option3" style="width: 100px;">線</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IsShowCutline",
  props: {
  },
  data() {
    return {
      cutlineMode: "0",
      isShowCutline: "1",
    };
  },
  watch: {
    "isShowCutline": function(){
      this.$store.commit("setDesignPreviewData", { key: 'isShowCutline', value: this.isShowCutline == 1});
    },
    "cutlineMode": function(){
      this.$store.commit("setDesignPreviewData", { key: 'cutlinePreviewMode', value: this.cutlineMode == 1});
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.preview-border{
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}

.preview-title{
  color: $text-white-color;
  background-color: $primary-main-color;
}
.radio-btn{
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}
</style>
